import {BuyBonusBalanceViewLandscape} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusBalance/BuyBonusBalanceViewLandscape';
import {KeypadView} from '@gongxigames/framework/slot/modules/keypad/KeypadView';
import {KeypadViewMobilePortrait} from '@gongxigames/framework/slot/modules/keypad/KeypadViewMobilePortrait';
import {Sprite} from 'pixi.js';

export class BuyBonusBalanceViewPortrait extends BuyBonusBalanceViewLandscape {
    public static readonly NAME: symbol = Symbol('BuyBonusBalanceViewPortrait');

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadViewMobilePortrait.NAME).mainSprite;
    }
}
